import { removeItem, setItem } from './local-storage';

export function broadcastMessageToTabs(key: string, value: unknown): void {
  setItem(key, value);
  removeItem(key);
}
